var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React, { Component, useState } from 'react';
import PropTypes from 'prop-types';
import AnimateHeight from 'react-animate-height';
import Icon from '../../components/Icon';

var AccordionHeader = function AccordionHeader(_ref) {
  var expanded = _ref.expanded,
      header = _ref.header,
      onClick = _ref.onClick,
      tooltip = _ref.tooltip,
      _ref$angleIcon = _ref.angleIcon,
      angleIcon = _ref$angleIcon === undefined ? 'down' : _ref$angleIcon,
      _ref$tooltipOpen = _ref.tooltipOpen,
      tooltipOpen = _ref$tooltipOpen === undefined ? false : _ref$tooltipOpen,
      _ref$tooltipIcon = _ref.tooltipIcon,
      tooltipIcon = _ref$tooltipIcon === undefined ? 'info-circle' : _ref$tooltipIcon;

  var _useState = useState(tooltipOpen),
      _useState2 = _slicedToArray(_useState, 2),
      open = _useState2[0],
      setOpen = _useState2[1];

  return React.createElement(
    'div',
    { className: 'AccordionItem__header', onClick: onClick },
    React.createElement(
      'div',
      { className: 'AccordionItem__header__row' },
      header,
      expanded && tooltip && React.createElement(
        'div',
        {
          className: 'AccordionItem__header__tooltop-icon',
          onClick: function onClick(e) {
            e.stopPropagation();
            setOpen(!open);
          } },
        React.createElement(Icon, { icon: tooltipIcon })
      ),
      React.createElement(
        'div',
        { className: 'AccordionItem__header__expand-icon' },
        React.createElement(Icon, { icon: 'angle-' + angleIcon })
      )
    ),
    expanded && open && React.createElement('div', {
      className: 'AccordionItem__header__tooltop',
      dangerouslySetInnerHTML: { __html: tooltip }
    })
  );
};

var AccordionContent = function AccordionContent(_ref2) {
  var content = _ref2.content,
      expanded = _ref2.expanded,
      animationDuration = _ref2.animationDuration,
      contentCollapsedHeight = _ref2.contentCollapsedHeight;
  return React.createElement(
    AnimateHeight,
    {
      duration: animationDuration || 170,
      height: expanded ? 'auto' : contentCollapsedHeight || 0,
      easing: 'ease-in',
      className: 'AccordionItem__content' },
    content
  );
};

var AccordionItem = function AccordionItem(_ref3) {
  var header = _ref3.header,
      content = _ref3.content,
      expanded = _ref3.expanded;
  return React.createElement(
    'div',
    { className: 'AccordionItem' + (expanded ? ' AccordionItem--expanded' : '') },
    header,
    content
  );
};

var Accordion = function (_Component) {
  _inherits(Accordion, _Component);

  function Accordion() {
    var _ref4;

    var _temp, _this, _ret;

    _classCallCheck(this, Accordion);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref4 = Accordion.__proto__ || Object.getPrototypeOf(Accordion)).call.apply(_ref4, [this].concat(args))), _this), _this.state = {
      expandedIndex: _this.props.initialExpandedIndex
    }, _this.handleSelectAccordionItem = function (e, key, item) {
      // Expand if content exists
      if (item.content) {
        _this.setState(function (prevState) {
          return {
            expandedIndex: prevState.expandedIndex === key ? null : key
          };
        });
      }

      // Call onClick if exists
      var onClickHeader = _this.props.onClickHeader;

      onClickHeader && onClickHeader(e, key, item);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Accordion, [{
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      var initialExpandedIndex = this.props.initialExpandedIndex;

      if (initialExpandedIndex !== prevProps.initialExpandedIndex) this.setState({ expandedIndex: initialExpandedIndex });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          animationDuration = _props.animationDuration,
          contentCollapsedHeight = _props.contentCollapsedHeight,
          children = _props.children,
          items = _props.items;
      var expandedIndex = this.state.expandedIndex;


      if (!items && (typeof children === 'undefined' ? 'undefined' : _typeof(children)) === 'object') {
        items = children.map(function (c, i) {
          return {
            header: c.props.children[0],
            tooltip: c.props.children[0].props.tooltipContent,
            tooltipOpen: c.props.children[0].props.tooltipOpen,
            content: c.props.children[1],
            key: i
          };
        });
      }

      items = items.map(function (item, index) {
        return {
          header: React.createElement(AccordionHeader, {
            header: item.header,
            expanded: index === expandedIndex,
            onClick: function onClick(e) {
              return _this2.handleSelectAccordionItem(e, index, item);
            },
            tooltip: item.tooltip,
            tooltipOpen: item.tooltipOpen,
            angleIcon: item.content ? 'down' : 'right'
          }),
          content: React.createElement(AccordionContent, {
            content: item.content,
            expanded: index === expandedIndex,
            animationDuration: animationDuration,
            contentCollapsedHeight: contentCollapsedHeight
          }),
          key: index
        };
      });

      return React.createElement(
        'div',
        { className: 'AccordionWidget' },
        items && items.map(function (item, index) {
          return React.createElement(AccordionItem, _extends({}, item, { expanded: index === expandedIndex }));
        })
      );
    }
  }]);

  return Accordion;
}(Component);

Accordion.propTypes = {
  /** List of items */
  items: PropTypes.arrayOf(PropTypes.shape({
    /** The clickable item header */
    header: PropTypes.string.isRequired,

    /** The click handler to override default behaviour */
    onClickHeader: PropTypes.function,

    /** The expandable content/component */
    content: PropTypes.element
  }))
};

export default Accordion;